import React, { ReactNode, useState } from 'react';
import { createPortal } from 'react-dom';
import isFunction from 'lodash/isFunction';
import {
  FSPHeader,
  FSPTitle,
  FullScreenPanel,
  FSPBody,
} from './full-screen-portal.styles';
import { usePortalRef } from '../../../utilities/portal';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorBoundaryComponentProps } from '../../../../components/error-boundary';

type IProps = {
  className?: string;
  titlePanel: ReactNode;
  buttonGroup: ReactNode | ((hasError: boolean) => ReactNode);
  children: ReactNode;
};

export const FullScreenPortal = ({
  className = '',
  titlePanel,
  buttonGroup,
  children,
}: IProps) => {
  const [hasError, setHasError] = useState<boolean>(false);
  const { getPortalContainer } = usePortalRef();
  const portalRef = getPortalContainer();

  const handleError = (error: Error, info: React.ErrorInfo) => {
    ErrorBoundaryComponentProps.onError(error, info);
    setHasError(true);
  };

  return portalRef
    ? createPortal(
        <FullScreenPanel className={className}>
          <FSPHeader>
            <FSPTitle>{titlePanel}</FSPTitle>
            {isFunction(buttonGroup) ? buttonGroup(hasError) : buttonGroup}
          </FSPHeader>
          <ErrorBoundary {...ErrorBoundaryComponentProps} onError={handleError}>
            <FSPBody className='modal-body'>{children}</FSPBody>
          </ErrorBoundary>
        </FullScreenPanel>,
        portalRef,
      )
    : null;
};
